export default "__VITE_ASSET__f73G05LB__"